import { __assign, __rest } from "tslib";
import React from "react";
import { Box, Card, IconButton, Modal, Typography, useTheme } from "@material-ui/core";
import { StylesProvider, ThemeProvider } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import classnames from "classnames";
import parse from "html-react-parser";
import { generateClassName, useSimpleModalStyles } from "./styles";
export var SimpleModal = function (_a) {
    var _b;
    var title = _a.title, open = _a.open, _c = _a.onClose, onClose = _c === void 0 ? function () { } : _c, _d = _a.footer, footer = _d === void 0 ? React.createElement(CloseIcon, { color: "disabled" }) : _d, text = _a.text, IconSvg = _a.IconSvg, extraContent = _a.extraContent, headerClass = _a.headerClass, icon = _a.icon, modalWidth = _a.modalWidth, props = __rest(_a, ["title", "open", "onClose", "footer", "text", "IconSvg", "extraContent", "headerClass", "icon", "modalWidth"]);
    var classes = useSimpleModalStyles();
    var theme = useTheme();
    return (React.createElement(StylesProvider, { generateClassName: generateClassName },
        React.createElement(ThemeProvider, { theme: theme },
            React.createElement(Modal, __assign({ className: classes.modal, disableEnforceFocus: true, disableAutoFocus: true, open: open }, props),
                React.createElement(Box, { width: modalWidth || 550 },
                    React.createElement(Card, { className: classes.card },
                        React.createElement(Box, { className: classnames(classes.modalHeader, (_b = {},
                                _b[headerClass] = headerClass,
                                _b)) },
                            React.createElement(Typography, { className: classes.title }, title),
                            React.createElement(IconButton, { className: classes.closeIcon, onClick: onClose },
                                React.createElement(CloseIcon, { color: "action" }))),
                        icon && (React.createElement(Box, { mb: 2, display: "flex", justifyContent: "center", alignItems: "center" }, icon)),
                        React.createElement(Box, null,
                            IconSvg && (React.createElement(Box, { display: "flex", justifyContent: "center", alignItems: "center", m: 3 },
                                React.createElement(IconSvg, null))),
                            React.createElement(Box, { className: classes.subTitleContainer },
                                React.createElement(Typography, { className: classes.subTitle }, parse(text))),
                            extraContent && extraContent),
                        React.createElement(Box, { className: classes.modalFooter }, footer)))))));
};
//# sourceMappingURL=SimpleModal.js.map